module.exports = __webpack_public_path__ + "img/post_pic1.fd78d538.png";